import { CMDBet } from "./CMDBet"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsBet implements ICommand
{

	public gameID : number = 0;
	public BetSource : number = 0;
	public bets : Array<CMDBet>;

	public constructor()
	{
		this.bets = new Array<CMDBet>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.gameID = ba.readInt53();
		this.BetSource = ba.readUint32();
		let betsSize:number = ba.readUint8();
		while (betsSize-- > 0)
		{
			let betsChild:CMDBet = new CMDBet();
			betsChild.fromBytes(ba);
			this.bets.push(betsChild);
		}
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.gameID);
		ba.writeUint32(this.BetSource);
		ba.writeUint8(this.bets.length);
		for (const betsChild of this.bets)
		{
			let tempBuf = betsChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsBet();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'gameID(Q)='+this.gameID+' ';
		str += 'BetSource(D)='+this.BetSource+' ';
		str += 'bets_size(B)='+this.bets.length + ' ';
		str += 'bets(CMDBet)=[';
		for (let betsChild in this.bets)
		{
			if (<number><unknown>betsChild > 0) str += ', ';
			str += this.bets[betsChild].toString();
		}
		str += '] ';
		return str;
	}

	public getCmdID() : number
	{
		return 55002;
	}

	public getCmdName() : string
	{
		return 'PsBet';
	}

}
